document.addEventListener('DOMContentLoaded', () => {
  function formatMoney(cents) {
    const fractionDigits = cents % 100 === 0 ? 0 : 2;
    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: 2,
    });
  }

  document.querySelectorAll('.variant-selector').forEach(selector => {
    const productId = selector.dataset.productId;
    const variantData = selector.querySelector(`[data-variant-json="${productId}"]`);
    if (!variantData) return;

    let variants;
    try {
      variants = JSON.parse(variantData.textContent);
    } catch (error) {
      console.error('Variant data could not be read.', error);
      return;
    }

    const selects = Array.from(selector.querySelectorAll('.variant-select'));
    const hiddenInput = document.getElementById(`variant-id-${productId}`);
    const price = document.getElementById(`price-${productId}`);
    const form = hiddenInput ? hiddenInput.closest('form') : null;
    const addButton = form ? form.querySelector('[name="add"]') : null;

    function findVariant() {
      const selectedValues = selects.map(select => select.value);
      return variants.find(variant =>
        variant.options.length === selectedValues.length &&
        variant.options.every((option, index) => option === selectedValues[index])
      );
    }

    function applyVariant() {
      const variant = findVariant();
      if (!variant) return;

      if (hiddenInput) hiddenInput.value = variant.id;
      if (price) price.textContent = variant.price === 0 ? 'TBA' : formatMoney(variant.price);

      if (addButton) {
        if (variant.available) {
          addButton.textContent = addButton.classList.contains('preorder') ? '⭐ Pre-Order' : '+ Add to Cart';
          addButton.disabled = false;
        } else {
          addButton.textContent = 'Sold Out';
          addButton.disabled = true;
        }
      }
    }

    applyVariant();
    selects.forEach(select => select.addEventListener('change', applyVariant));
  });

  const mainProductImage = document.getElementById('product-main-image');
  const productThumbnails = document.querySelectorAll('.product-gallery-thumb');

  if (mainProductImage && productThumbnails.length > 0) {
    productThumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', () => {
        const imageUrl = thumbnail.dataset.full;
        if (!imageUrl) return;
        mainProductImage.src = imageUrl;
        productThumbnails.forEach(candidate => candidate.classList.remove('is-active'));
        thumbnail.classList.add('is-active');
      });
    });
  }

  const cartLayout = document.getElementById('cart-layout');
  if (!cartLayout) return;

  const subtotal = document.getElementById('cart-subtotal');
  const cartStatus = document.getElementById('cart-status');
  const routeRoot = window.Shopify?.routes?.root || '/';

  function cartUrl(path) {
    const root = routeRoot.endsWith('/') ? routeRoot : `${routeRoot}/`;
    return `${root}${path.replace(/^\//, '')}`;
  }

  async function requestCart(path, body) {
    const response = await fetch(cartUrl(path), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(`Cart request failed with status ${response.status}`);
    }

    return response.json();
  }

  function setCartStatus(message) {
    if (cartStatus) cartStatus.textContent = message;
  }

  function setRowLoading(row, loading) {
    if (row) row.classList.toggle('is-loading', loading);
  }

  async function changeQuantity(line, quantity) {
    const row = cartLayout.querySelector(`[data-line="${line}"]`);
    setRowLoading(row, true);
    setCartStatus('');

    try {
      const cart = await requestCart('cart/change.js', { line, quantity });
      const quantityValue = document.getElementById(`qty-${line}`);
      if (quantityValue) quantityValue.textContent = quantity;

      const updatedItem = cart.items[line - 1];
      const linePrice = document.getElementById(`line-price-${line}`);
      if (updatedItem && linePrice) linePrice.textContent = formatMoney(updatedItem.final_line_price);
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

      const cartCount = document.querySelector('.cart-count');
      if (cartCount) cartCount.textContent = cart.item_count;
    } catch (error) {
      console.error('Cart quantity could not be updated.', error);
      setCartStatus("We couldn't update that quantity. Refresh the page and try again.");
    } finally {
      setRowLoading(row, false);
    }
  }

  async function removeLine(line) {
    const row = cartLayout.querySelector(`[data-line="${line}"]`);
    setRowLoading(row, true);
    setCartStatus('');

    try {
      await requestCart('cart/change.js', { line, quantity: 0 });
      window.location.reload();
    } catch (error) {
      console.error('Cart item could not be removed.', error);
      setCartStatus("We couldn't remove that item. Refresh the page and try again.");
      setRowLoading(row, false);
    }
  }

  cartLayout.addEventListener('click', event => {
    const decreaseButton = event.target.closest('.qty-minus');
    const increaseButton = event.target.closest('.qty-plus');
    const removeButton = event.target.closest('.cart-remove-btn');

    if (decreaseButton || increaseButton) {
      const button = decreaseButton || increaseButton;
      const line = Number.parseInt(button.dataset.line, 10);
      const delta = Number.parseInt(button.dataset.delta, 10);
      const quantityValue = document.getElementById(`qty-${line}`);
      const currentQuantity = quantityValue ? Number.parseInt(quantityValue.textContent, 10) : Number.NaN;

      if (!Number.isInteger(line) || !Number.isInteger(delta) || !Number.isInteger(currentQuantity)) {
        setCartStatus("We couldn't read that quantity. Refresh the page and try again.");
        return;
      }

      const nextQuantity = Math.max(1, currentQuantity + delta);
      if (nextQuantity !== currentQuantity) changeQuantity(line, nextQuantity);
    }

    if (removeButton) {
      const line = Number.parseInt(removeButton.dataset.line, 10);
      if (Number.isInteger(line)) {
        removeLine(line);
      } else {
        setCartStatus("We couldn't identify that item. Refresh the page and try again.");
      }
    }
  });
});
